import React, { useState } from "react";
import {
  Info,
  Zap,
  Target,
  Settings,
  Mic,
  BarChart2,
  HelpCircle,
} from "lucide-react";
import AudioRecorder from "./AudioRecorder"; // Ajuste o caminho se necessário
import TensionResult from "./TensionResult"; // Ajuste o caminho se necessário

function TensionAnalyzerPage() {
  const [analysisResult, setAnalysisResult] = useState(null);
  const [selectedStringInfo, setSelectedStringInfo] = useState(null); // To pass string info to results

  const handleAudioProcessed = (result) => {
    setAnalysisResult(result);
  };

  const handleStringSelected = (stringData) => {
    // stringData could be the string object from JSON or the generic type string
    setSelectedStringInfo(stringData);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Left Column: Instructions & Info */}
        <div className="lg:col-span-1 space-y-6">
          {/* How to Use Section */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-4 text-dark-text flex items-center">
              <HelpCircle size={20} className="mr-2 text-brand-blue" /> How to
              Use
            </h2>
            <ol className="space-y-3 text-medium-text text-sm">
              <li className="flex items-start">
                <span className="mr-2 text-brand-blue font-semibold">1.</span>{" "}
                Select your string type (optional, but recommended for
                accuracy).
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-brand-blue font-semibold">2.</span>{" "}
                Place device near strings (5-10 cm).
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-brand-blue font-semibold">3.</span>{" "}
                Tap <Mic size={16} className="inline mx-1" /> to start
                recording.
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-brand-blue font-semibold">4.</span>{" "}
                Gently tap the string to make a sound.
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-brand-blue font-semibold">5.</span>{" "}
                Record for 2-4 seconds.
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-brand-blue font-semibold">6.</span>{" "}
                Tap Stop, then Analyze.
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-brand-blue font-semibold">7.</span>{" "}
                View estimated tension!
              </li>
            </ol>
            <div className="mt-4 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded">
              <h3 className="font-semibold text-yellow-800 text-sm mb-1">
                Tips for Best Results:
              </h3>
              <ul className="list-disc pl-4 space-y-1 text-xs text-yellow-700">
                <li>Record in a quiet environment.</li>
                <li>Ensure the string is clean.</li>
                <li>Take multiple measurements for consistency.</li>
              </ul>
            </div>
          </div>

          {/* About Tension Section */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-4 text-dark-text flex items-center">
              <Info size={20} className="mr-2 text-brand-blue" /> About String
              Tension
            </h2>
            <div className="space-y-3">
              <div className="p-3 bg-blue-50 rounded-lg border border-blue-100">
                <h3 className="font-semibold text-low-tension mb-1 text-sm flex items-center">
                  <Zap size={16} className="mr-1" /> Low (&lt;50 lbs)
                </h3>
                <p className="text-xs text-medium-text">
                  More power, larger sweet spot, less control. Good for comfort.
                </p>
              </div>
              <div className="p-3 bg-green-50 rounded-lg border border-green-100">
                <h3 className="font-semibold text-medium-tension mb-1 text-sm flex items-center">
                  <Settings size={16} className="mr-1" /> Medium (50-55 lbs)
                </h3>
                <p className="text-xs text-medium-text">
                  Balanced power and control. Suits most players.
                </p>
              </div>
              <div className="p-3 bg-red-50 rounded-lg border border-red-100">
                <h3 className="font-semibold text-high-tension mb-1 text-sm flex items-center">
                  <Target size={16} className="mr-1" /> High (&gt;55 lbs)
                </h3>
                <p className="text-xs text-medium-text">
                  More control, less power. Better for advanced players
                  generating own power.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Interaction & Results */}
        <div className="lg:col-span-2 space-y-6">
          {/* Interaction Area: Recorder + String Selector */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-4 text-dark-text flex items-center">
              <BarChart2 size={20} className="mr-2 text-brand-blue" /> Measure
              Tension
            </h2>
            <AudioRecorder
              onAudioProcessed={handleAudioProcessed}
              onStringSelected={handleStringSelected}
            />
          </div>

          {/* Results Area */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-4 text-dark-text">
              Analysis Result
            </h2>
            <TensionResult
              result={analysisResult}
              selectedStringInfo={selectedStringInfo}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TensionAnalyzerPage;
